import { render, staticRenderFns } from "./UserProduct.vue?vue&type=template&id=4b0eb7fc&scoped=true"
import script from "./UserProduct.vue?vue&type=script&lang=js"
export * from "./UserProduct.vue?vue&type=script&lang=js"
import style0 from "./UserProduct.vue?vue&type=style&index=0&id=4b0eb7fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0eb7fc",
  null
  
)

export default component.exports